module.exports = __webpack_public_path__ + "img/03.0a817873.jpg";